import { render, staticRenderFns } from "./transaction.html?vue&type=template&id=f8e4ff82&scoped=true&"
import script from "./transaction.js?vue&type=script&lang=js&"
export * from "./transaction.js?vue&type=script&lang=js&"
import style0 from "./transaction.css?vue&type=style&index=0&id=f8e4ff82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e4ff82",
  null
  
)

export default component.exports